import React from "react";

import { METRIC_TABS } from "@main/pages/Release/views/MetricDetails/ReleaseMetricDetailsLayout";
import { useParams, useSearchParams } from "react-router-dom";

import RedirectWithLoading from "./RedirectWithLoading";
import { RoutePaths } from "../config/routePaths";

export const ReleaseMetricRedirect = () => {
  const { workspaceSlug, appKey, metricKey } = useParams<{
    workspaceSlug: string;
    appKey: string;
    metricKey: string;
  }>();
  const [searchParams] = useSearchParams();

  const defaultPath =
    METRIC_TABS.find((tab) => tab.metrics.includes(metricKey ?? ""))?.path ?? RoutePaths.RELEASE_METRIC_SCORE;

  return (
    <RedirectWithLoading
      path={defaultPath}
      dynamicValues={{ workspaceSlug, appKey, metricKey }}
      search={searchParams.toString()}
    />
  );
};
